import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import { Skeleton } from 'primereact/skeleton';
import { SkeletonInput } from '../../functions/utils/SkeletonInput';
import { RadioButton } from 'primereact/radiobutton';
import { Chip } from 'primereact/chip';

export const GralInput = ({ arr, register }) => {
  const maxLength = 20; // Define el límite de caracteres para truncar el texto

  return (
    <>
  {arr.length > 0 ? (
    arr.map(({ id, name, name_raw, value, concept, concept_raw, ocupation }, i) => {
      const name_raw2 = name_raw ? name_raw : concept_raw;
      return (
        <div key={id} className='container-input'>
          <p id={`tooltip-${id}`} className='truncated-text'>
            {name
              ? name.length > maxLength
                ? `${name.slice(0, maxLength)}...`
                : name
              : concept.length > maxLength
                ? `${concept.slice(0, maxLength)}...`
                : concept}
          </p>
          <div>
            <InputText
              className='TextInput'
              placeholder='Top'
              tooltip={name ? name : concept}
              tooltipOptions={{ position: 'top' }}
              {...register(name_raw2, { value })}
            />
            {ocupation ? (
              <div className='Tooltip'>
                {ocupation === 1 && (
                  <div className='TooltipIndividual'>
                    <Chip style={{background:"#34b9de", color:"#ffffff", height:"20px"}} label="Financiero" />
                  </div>
                )}
                {ocupation === 2 && (
                  <div className='TooltipIndividual'>
                    <Chip style={{background:"#34b9de", color:"#ffffff",height:"20px"}} label="Puro" />
                  </div>
                )}
                {ocupation === 3 && (
                  <>
                    <div className='TooltipIndividual'>
                      <Chip style={{background:"#34b9de", color:"#ffffff",height:"20px"}} label="Puro"  />
                    </div>
                    <div className='TooltipIndividual'>
                      <Chip style={{background:"#34b9de", color:"#ffffff",height:"20px"}} label="Financiero"  />
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className='Tooltip'>
                <div className='TooltipIndividual'>
                  <Chip style={{background:"#34b9de", color:"#ffffff",height:"20px"}} label="Puro" />
                </div>
              </div>
            )}
          </div>
        </div>
      );
    })
  ) : (
    <SkeletonInput />
  )}
</>


  );
};
